import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import FacebookPageSelectionModal from "../../components/Modals/FacebookPageSelectionModal";
import InstagramPageSelectionModal from "../../components/Modals/InstagramPageSelectionModal";
import { useCompleteReportConnect } from "./hooks/useCompleteReportConnect";

const ReportBuilderConnectReturn: React.FC = () => {
  const { picker, connectingId, connectFacebookPage, connectInstagramAccount, cancel } =
    useCompleteReportConnect();

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f4f6f8",
      }}
    >
      <CircularProgress size={60} thickness={5} />
      <Typography mt={2} variant="h6" sx={{ color: "#555" }}>
        Finishing your connection...
      </Typography>

      <FacebookPageSelectionModal
        open={picker?.kind === "facebook"}
        onClose={cancel}
        pages={picker?.kind === "facebook" ? picker.pages : []}
        onSelectPage={connectFacebookPage}
        connectingPageId={connectingId}
      />

      <InstagramPageSelectionModal
        open={picker?.kind === "instagram"}
        onClose={cancel}
        pages={picker?.kind === "instagram" ? picker.accounts : []}
        onSelectPage={connectInstagramAccount}
        connectingPageId={connectingId}
      />
    </Box>
  );
};

export default ReportBuilderConnectReturn;
